import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const PatDetalhe = ({ data }) => {
  const [detalhes, setDetalhes] = useState([]);
  const [soma, setSoma] = useState(0);

  const { request: requestDetalhe, data: dataDetalhe, errors: errorsDetalhe } = useApiClient();

  useEffect(() => {
    requestDetalhe(apiRoutes.extratofiscal.extrato.detalhePat, { numeroProcesso: data.pat });
  }, [data.pat, requestDetalhe]);

  useEffect(() => {
    if (dataDetalhe) {
      setDetalhes(dataDetalhe.result);
      setSoma(dataDetalhe.result.reduce((total, detalhe) => total + detalhe.total, 0));
    }
    if (errorsDetalhe) {
      toast.error(errorsDetalhe.message);
    }
  }, [dataDetalhe, detalhes, errorsDetalhe]);

  return (
    <div>
      <Row>
        <Col>
          {detalhes?.length > 0 ? (
            <div>
              <table className="table table-striped table-bordered" width="90%">
                <thead>
                  <tr>
                    <th>Ocorrência</th>
                    <th>ICMS (R$)</th>
                    <th>Multa (R$)</th>
                    <th>FECOP (R$)</th>
                    <th>Total (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  {detalhes?.map((debitoDetalhado) => (
                    <tr>
                      <td>{debitoDetalhado.ocorrencia}</td>
                      <td className="text-right">
                        {debitoDetalhado.icms.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                      <td className="text-right">
                        {debitoDetalhado.multa.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                      <td className="text-right">
                        {debitoDetalhado.fecop.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                      <td className="text-right">
                        {debitoDetalhado.total.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <b>Total de Débitos R$ {soma.toLocaleString("pt-br", { minimumFractionDigits: 2 })} </b>
                </tfoot>
              </table>
            </div>
          ) : (
            <b>Nenhum registro para exibir</b>
          )}
          ;
        </Col>
      </Row>
    </div>
  );
};

export default PatDetalhe;
